<template>
    <div class="row">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>

        <div class="d-none d-lg-block col-lg-2"></div>
        <div class="col-12 col-lg-8">
            <h1>Student Update</h1>

            <div class="row">
                <div class="mb-2 col-12 col-md-6">
                    <div class="input-group">
                        <span class="input-group-text">District</span>
                        <select v-model="district" class="form-control">
                            <option v-for="d in districts" :value="d.id">{{ d.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="mb-3 col-12 col-md-6">
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                        <input v-model="searchString" type="search" class="form-control bg-white" placeholder="Student search" @keyup="search" aria-label="Student search" aria-describedby="basica-addon1"/>
                    </div>
                </div>
            </div>
            
            <ul class="list-group">
                <li v-for="(st, index) in students" class="list-group-item d-flex align-items-center" :class="st.duplicate ? 'duplicate' : ''">
                    <template v-if="editing == st.id">
                        <admin-student-update-form
                            :student="st"
                            :district="district"
                            :index="index"
                        ></admin-student-update-form>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(st.id)"><i class="fas fa-user-edit"></i></button>
                        <button type="button" class="btn btn-sm btn-primary" @click="remove(st.id)"><i class="fas fa-user-times"></i></button>
                        <div class="ms-3">
                            <h6 class="text-primary m-0">{{st.last_name}}, {{ st.first_name }}  ({{ st.grad_year }}) 
                            </h6>
                            <span class="text-muted">{{ st.email }}</span>
                        </div>
                    </template>
                </li>
                <li class="list-group-item">
                    <admin-student-update-form :district="district"></admin-student-update-form>
                </li>
            </ul>
            <div class="mt-4">
                <home-button></home-button>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import AdminStudentUpdateForm from './AdminStudentUpdateForm.vue';
import HomeButton from './HomeButton.vue';

export default {
    components: { Loading, AdminStudentUpdateForm, HomeButton },

    data() {
        return {
            districts: [],
            district: null,

            searchString: '',
            isLoading: false,
            students: [],
            changeTimeout: null,
            editing: -1
        }
    },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/admin/users/allowed-districts')
            .then(response => {
                
                this.districts = response.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    watch: {
        district: function (n, o) {
            this.students = [];
        }
    },

    methods: {
        search: function() {
            if (this.district === null) {
                return;
            }

            clearTimeout(this.changeTimeout);

            this.changeTimeout = setTimeout(() => {
                this.isLoading = true;
                axios
                    .get(`/api/students?search=${this.searchString}&district=${this.district}&limit=25`)
                    .then((response) => {
                        this.students = response.data.students;
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }, 1000);
        },

        remove: function(id) {
            this.isLoading = true;
            axios
                .delete(`/api/admin/students/${id}`)
                .then((response) => {
                    if (response.data > 0) {
                        this.search();
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        edit: function(id) {
            this.editing = this.editing == id ? -1 : id;
        }
    }



}
</script>